"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INITIAL_CONTEXT = exports.STATUS_FINISH_INTEGRATION = exports.STATUS_CONTINUE_INTEGRATION = exports.STATUS_MANUAL = exports.STATUS_DEFAULT = void 0;
var STATUS_DEFAULT = 'default';
exports.STATUS_DEFAULT = STATUS_DEFAULT;
var STATUS_MANUAL = 'manual';
exports.STATUS_MANUAL = STATUS_MANUAL;
var STATUS_CONTINUE_INTEGRATION = 'completed';
exports.STATUS_CONTINUE_INTEGRATION = STATUS_CONTINUE_INTEGRATION;
var STATUS_FINISH_INTEGRATION = 'finished';
exports.STATUS_FINISH_INTEGRATION = STATUS_FINISH_INTEGRATION;
var INITIAL_CONTEXT = {
  activeStep: null,
  nextStep: null
};
exports.INITIAL_CONTEXT = INITIAL_CONTEXT;